module.exports = __webpack_public_path__ + "static/media/エコキュート.1631abdb.jpg";